import styled from '@emotion/styled';

import { Table as BaseTable } from 'components';

export const Title = styled.h1`
  font-size: 2.6rem;
  font-weight: normal;
  margin: 0 0 1.43rem;
`;

export const CaseInfo = styled.div`
  display: flex;
  margin-bottom: 2.5rem;
`;

export const DetailsColumn = styled.div`
  width: 50%;

  span {
    font-size: 1.75rem;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 700;
    display: inline-block;
    width: 100%;
    text-align: ${({ alignRight }) => (alignRight ? 'right' : 'left')};
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const Table = styled(BaseTable)`
  th:first-of-type {
    width: 70%;
  }
`;

export const Exception = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
`;

export const AssetSection = styled.div`
  margin: 30px 0;
  color: #000;
`;

export const AssetHeader = styled.h2`
  margin: 0;
  padding: 0 15px 15px;
  border-bottom: 1px solid #ddd;
  font-size: 24px;
`;

export const NoAssetsMessage = styled.p`
  margin: 0;
  margin-top: 20px;
  padding: 0 25px;
`;

export const RmaDetailTable = styled.table`
  padding: 20px 0 0 100px;
  width: 100%;
`;

export const Link = styled.a`
  color: ${({ color, theme }) => theme.colors[color || 'item']};
`;
